import { useQuery } from "@apollo/client";
import { GET_HEALTHCOACHING_PATIENTS_LIST } from "../../graphql/queries";
import { IGetHealthCoachingPatientsListOutput, IGetHealthCoachingPatientsListInput, IGetHealthCoachingPatientsListPatients, IGetHealthCoachingPatientsListPage } from "../../graphql/types/queries/patient";
import { Flex, Box, Text, Card, Heading } from "rebass";
import { Skeleton } from "../../components/loadingSkeleton/Skeleton";
import styled from "styled-components";
import { useEffect, useState } from "react";
import Select, { ActionMeta, components } from "react-select";
import { ReactSelectStyles } from '../../styles/ReactSelectStyles';
import { Checkbox } from "../../components/CheckboxInput";
import { useNavigate } from "react-router-dom";

const Wrapper = styled(Flex)`
  overflow: auto;
  flex-direction: column;
  padding-right: 16px;
  padding-left: 16px;
  overflow-x: hidden;
  flex: 1;
  border-bottom: 1px solid rgba(108, 137, 183, 0.5);
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;
const HoverableCard = styled(Card)`
  transition:all 0.3s ease;
  flex: initial;
  background: white;
`

const RowLoading = () => {
  return (
    <HoverableCard mb={2} style={{ opacity: 1, boxShadow: '0px 4px 20px rgb(0 0 0 / 10%)' }} onMouseEnter={() => { }} onMouseLeave={() => { }}>
      <Flex style={{ width: '100%', minHeight: '82px', padding: '18px 12px' }}>
        <Box width={'80px'} style={{ alignSelf: 'center', paddingRight: '12px' }}>
          <Text textAlign={'center'} style={{ color: '#7992B3', fontSize: '12px' }}><Skeleton /></Text>
        </Box>
        <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
        <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center', paddingRight: '12px' }}>
          <Text style={{ color: '#7992B3', fontSize: '12px' }}><Skeleton /></Text>
        </Box>
        <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
        <Flex width={'280px'} style={{ paddingLeft: '12px', alignSelf: 'center' }}>
          <Flex flexDirection={'column'} flex={1}>
            <Text style={{ color: '#7992B3', fontSize: '12px' }}><Skeleton /></Text>
            <Text style={{ color: '#7992B3', fontSize: '12px' }}><Skeleton /></Text>
          </Flex>
          <Flex style={{ paddingLeft: '24px' }} alignItems='center'>

          </Flex>
        </Flex>
      </Flex>
    </HoverableCard>
  )
}

const Row = ({ row, onGoToProfile, hoveredId, setHover, onGoToMessages }: { row: IGetHealthCoachingPatientsListPatients, setHover: (id: string | null) => void, onGoToMessages: () => void, onGoToProfile: () => void, hoveredId: string | null }) => {
  return (
    <HoverableCard onClick={onGoToProfile} mb={2} style={{ opacity: !hoveredId || hoveredId === row.id ? 1 : 0.7, boxShadow: !hoveredId || hoveredId === row.id ? '0px 4px 20px rgb(0 0 0 / 10%)' : '0px 4px 20px rgb(0 0 0 / 0%)' }} onMouseEnter={() => setHover(row.id)} onMouseLeave={() => setHover(null)}>
      <Flex style={{ width: '100%', minHeight: '82px', padding: '18px 12px' }} >
        <Flex flex={1} flexDirection={['column', 'row', 'row']}>
          <Flex flex={1}>
            <Box width={'80px'} style={{ alignSelf: 'center' }}>
              <Text textAlign={'center'} style={{ color: '#7992B3', fontSize: '14px', fontWeight: 600 }}>{row.athenaId}</Text>
            </Box>
            <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
            <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
              <Text style={{ color: '#7992B3', fontSize: '14px', fontWeight: 600 }}>{`${(row.lastName || '').toUpperCase()} ${row.firstName}`}</Text>
            </Box>
          </Flex>
          <Box style={{ background: '#E2E2E2' }} height={['12px', '100%', '100%']} width={[0, '1px', '1px']}></Box>
        </Flex>
        <Flex style={{ paddingLeft: '24px' }} alignItems='center' flexDirection={['column', 'row', 'row']}>
          <svg style={{ cursor: 'pointer' }} onClick={(e)=>{
            e.preventDefault()
            e.stopPropagation()
            onGoToMessages()}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V21C2.00031 21.1772 2.04769 21.3511 2.1373 21.504C2.22691 21.6569 2.35553 21.7832 2.51 21.87C2.65946 21.9547 2.82821 21.9995 3 22C3.17948 21.9999 3.35564 21.9516 3.51 21.86L8 19.14C8.16597 19.0412 8.35699 18.9926 8.55 19H19C19.7956 19 20.5587 18.6839 21.1213 18.1213C21.6839 17.5587 22 16.7956 22 16V6C22 5.20435 21.6839 4.44129 21.1213 3.87868C20.5587 3.31607 19.7956 3 19 3ZM8 12C7.80222 12 7.60888 11.9414 7.44443 11.8315C7.27998 11.7216 7.15181 11.5654 7.07612 11.3827C7.00043 11.2 6.98063 10.9989 7.01921 10.8049C7.0578 10.6109 7.15304 10.4327 7.29289 10.2929C7.43275 10.153 7.61093 10.0578 7.80491 10.0192C7.99889 9.98063 8.19996 10.0004 8.38268 10.0761C8.56541 10.1518 8.72159 10.28 8.83147 10.4444C8.94135 10.6089 9 10.8022 9 11C9 11.2652 8.89464 11.5196 8.70711 11.7071C8.51957 11.8946 8.26522 12 8 12ZM12 12C11.8022 12 11.6089 11.9414 11.4444 11.8315C11.28 11.7216 11.1518 11.5654 11.0761 11.3827C11.0004 11.2 10.9806 10.9989 11.0192 10.8049C11.0578 10.6109 11.153 10.4327 11.2929 10.2929C11.4327 10.153 11.6109 10.0578 11.8049 10.0192C11.9989 9.98063 12.2 10.0004 12.3827 10.0761C12.5654 10.1518 12.7216 10.28 12.8315 10.4444C12.9414 10.6089 13 10.8022 13 11C13 11.2652 12.8946 11.5196 12.7071 11.7071C12.5196 11.8946 12.2652 12 12 12ZM16 12C15.8022 12 15.6089 11.9414 15.4444 11.8315C15.28 11.7216 15.1518 11.5654 15.0761 11.3827C15.0004 11.2 14.9806 10.9989 15.0192 10.8049C15.0578 10.6109 15.153 10.4327 15.2929 10.2929C15.4327 10.153 15.6109 10.0578 15.8049 10.0192C15.9989 9.98063 16.2 10.0004 16.3827 10.0761C16.5654 10.1518 16.7216 10.28 16.8315 10.4444C16.9414 10.6089 17 10.8022 17 11C17 11.2652 16.8946 11.5196 16.7071 11.7071C16.5196 11.8946 16.2652 12 16 12Z" fill="#344F7A" />
          </svg>
          <Box width={[0, '24px', '24px']} />
          {!!row.athenaId && (
            <svg onClick={onGoToProfile} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }}>
              <path d="M28.0078 20.1123L28.0049 20.1094L28.0019 20.1064C26.7099 17.373 24.709 15.9668 22.0459 15.9668C19.3828 15.9668 17.3818 17.376 16.0869 20.1064V20.1094C15.9287 20.4463 15.9287 20.8389 16.0869 21.1758C17.3818 23.9062 19.3828 25.3125 22.0459 25.3125C24.709 25.3125 26.7099 23.9033 28.0049 21.1729C28.1631 20.8359 28.1631 20.4463 28.0078 20.1123ZM22.0459 23.4375C20.2266 23.4375 18.8994 22.5586 17.9121 20.6396C18.8965 18.7207 20.2266 17.8418 22.0459 17.8418C23.8652 17.8418 25.1924 18.7207 26.1797 20.6396C25.1953 22.5586 23.8652 23.4375 22.0459 23.4375Z" fill="#344F7A" />
              <path d="M20.4199 20.6543C20.4199 21.0894 20.5928 21.5067 20.9004 21.8144C21.2081 22.1221 21.6254 22.2949 22.0605 22.2949C22.4957 22.2949 22.913 22.1221 23.2206 21.8144C23.5283 21.5067 23.7012 21.0894 23.7012 20.6543C23.7012 20.2192 23.5283 19.8019 23.2206 19.4942C22.913 19.1865 22.4957 19.0137 22.0605 19.0137C21.6254 19.0137 21.2081 19.1865 20.9004 19.4942C20.5928 19.8019 20.4199 20.2192 20.4199 20.6543ZM3.98438 6.79688H24.6094V14.209H26.7188V5.625C26.7188 5.10645 26.2998 4.6875 25.7812 4.6875H2.8125C2.29395 4.6875 1.875 5.10645 1.875 5.625V20.8594C1.875 21.3779 2.29395 21.7969 2.8125 21.7969H13.125V19.6875H3.98438V6.79688Z" fill="#344F7A" />
              <path d="M21.2373 9.90528L20.1592 8.82715C20.0683 8.73633 19.9189 8.73633 19.8281 8.82715L14.4433 14.2178L11.9209 11.6924C11.8301 11.6016 11.6807 11.6016 11.5898 11.6924L7.3623 15.9199C7.27148 16.0108 7.27148 16.1602 7.3623 16.251L8.44043 17.3291C8.53125 17.4199 8.68066 17.4199 8.77148 17.3291L11.7539 14.3467L14.2764 16.8721C14.3672 16.9629 14.5166 16.9629 14.6074 16.8721L21.2373 10.2363C21.331 10.1455 21.331 9.9961 21.2373 9.90528Z" fill="#344F7A" />
            </svg>
          )}
        </Flex>
      </Flex>
    </HoverableCard >
  )
}


const Header = () => {
  return (
    <Flex style={{ width: '100%', minHeight: '82px', padding: '18px 24px' }}>
      <Box width={'80px'} style={{ alignSelf: 'center' }}>
        <Flex flexDirection={'row'} justifyContent='center'>
          {/* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.75 15.75L12.3855 12.3795L15.75 15.75ZM14.25 7.875C14.25 9.56576 13.5784 11.1873 12.3828 12.3828C11.1873 13.5784 9.56576 14.25 7.875 14.25C6.18424 14.25 4.56274 13.5784 3.36719 12.3828C2.17165 11.1873 1.5 9.56576 1.5 7.875C1.5 6.18424 2.17165 4.56274 3.36719 3.36719C4.56274 2.17165 6.18424 1.5 7.875 1.5C9.56576 1.5 11.1873 2.17165 12.3828 3.36719C13.5784 4.56274 14.25 6.18424 14.25 7.875V7.875Z" stroke="#344F7A" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" />
          </svg> */}

          <Text textAlign={'center'} style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>ID</Text>
        </Flex>
      </Box>
      <Box style={{ width: '1px', background: 'transparent' }}></Box>
      <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
        <Flex flexDirection={'row'}>
          {/* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.75 15.75L12.3855 12.3795L15.75 15.75ZM14.25 7.875C14.25 9.56576 13.5784 11.1873 12.3828 12.3828C11.1873 13.5784 9.56576 14.25 7.875 14.25C6.18424 14.25 4.56274 13.5784 3.36719 12.3828C2.17165 11.1873 1.5 9.56576 1.5 7.875C1.5 6.18424 2.17165 4.56274 3.36719 3.36719C4.56274 2.17165 6.18424 1.5 7.875 1.5C9.56576 1.5 11.1873 2.17165 12.3828 3.36719C13.5784 4.56274 14.25 6.18424 14.25 7.875V7.875Z" stroke="#344F7A" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" />
          </svg> */}

          <Text style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>Name</Text>
        </Flex>
      </Box>
      <Box style={{ width: '1px', background: 'transparent' }}></Box>
      {/* <Box width={['initial', '280px', '280px']} style={{ paddingLeft: '12px', alignSelf: 'center' }}>
        <Flex flexDirection={'row'}>
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.28123 9H8.71872C9.38747 9 9.72185 9.80938 9.24997 10.2813L5.53123 14C5.23748 14.2937 4.76248 14.2937 4.47185 14L0.749977 10.2813C0.278102 9.80938 0.612477 9 1.28123 9ZM9.24997 5.71875L5.53123 2.00001C5.23748 1.70626 4.76248 1.70626 4.47185 2.00001L0.749977 5.71875C0.278102 6.19063 0.612477 7 1.28123 7H8.71872C9.38747 7 9.72185 6.19063 9.24997 5.71875Z" fill="#344F7A" fill-opacity="0.6" />
          </svg>

          <Text style={{ color: '#7992B3', fontSize: '12px' }} ml={2}>Visit</Text>
        </Flex>
      </Box> */}
    </Flex>
  )
}
const Footer: React.FC<{ page: IGetHealthCoachingPatientsListPage, goToPage: (pageNumber: number) => void }> = ({ page, goToPage }) => {
  const [pages, setPages] = useState<Array<{ value: number, label: string }>>([])
  const [selpage, setSelPage] = useState<{ value: number, label: string }>()
  useEffect(() => {
    const p: Array<{ value: number, label: string }> = []
    for (let index = 0; index < page.totalPages; index++) {
      p.push({
        value: index,
        label: (index + 1).toString()
      })

    }
    setPages(p)
    setSelPage(p[p.findIndex(x => x.value === page.currentPage)])
  }, [])

  useEffect(() => {
    setSelPage(pages[pages.findIndex(x => x.value === page.currentPage)])

  }, [pages])

  useEffect(() => {
    console.log('UEEE', page.totalPages)
    setSelPage({
      value: page.currentPage,
      label: (page.currentPage + 1).toString()
    })

  }, [page.currentPage])
  const goToFirst = () => {
    if (page.currentPage < 1) return
    goToPage(0)
  }
  const goToPrevious = () => {
    if (page.currentPage < 1) return
    goToPage(page.currentPage - 1)
  }
  const goToNext = () => {
    if (page.currentPage >= page.totalPages - 1) return
    goToPage(page.currentPage + 1)
  }
  const goToLast = () => {
    if (page.currentPage >= page.totalPages - 1) return
    goToPage(page.totalPages - 1)
  }
  console.log({ selpage })
  return (
    <Flex justifyContent={'flex-end'} mb={'60px'} mt={2} alignItems={'center'} paddingRight={'24px'}>
      <svg onClick={goToFirst} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '16px', cursor: page.currentPage > 0 ? 'pointer' : 'not-allowed', opacity: page.currentPage > 0 ? 1 : 0.1 }}>
        <path d="M15.5 1.48875V16.5112C15.4972 16.7772 15.4237 17.0376 15.2872 17.2658C15.1506 17.494 14.9558 17.6818 14.7227 17.8099C14.4896 17.938 14.2267 18.0019 13.9608 17.9949C13.695 17.988 13.4357 17.9105 13.2097 17.7703L2 10.7597V17.25C2 17.4489 1.92098 17.6397 1.78033 17.7803C1.63968 17.921 1.44891 18 1.25 18C1.05109 18 0.860322 17.921 0.71967 17.7803C0.579018 17.6397 0.5 17.4489 0.5 17.25V0.75C0.5 0.551088 0.579018 0.360322 0.71967 0.21967C0.860322 0.0790178 1.05109 0 1.25 0C1.44891 0 1.63968 0.0790178 1.78033 0.21967C1.92098 0.360322 2 0.551088 2 0.75V7.24031L13.2097 0.229688C13.4354 0.0879731 13.695 0.0091765 13.9614 0.00145626C14.2278 -0.00626398 14.4915 0.0573728 14.7251 0.185778C14.9586 0.314183 15.1536 0.502688 15.2899 0.731776C15.4261 0.960865 15.4987 1.22221 15.5 1.48875Z" fill="#6c89b7" />
      </svg>

      <svg onClick={goToPrevious} width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '16px', cursor: page.currentPage > 0 ? 'pointer' : 'not-allowed', opacity: page.currentPage > 0 ? 1 : 0.1 }}>
        <path d="M8.09075 0.593966L0.4445 7.14615C0.321318 7.25177 0.222439 7.38278 0.154648 7.5302C0.086857 7.67762 0.0517578 7.83796 0.0517578 8.00022C0.0517578 8.16248 0.086857 8.32282 0.154648 8.47023C0.222439 8.61765 0.321318 8.74866 0.4445 8.85428L8.09075 15.4065C8.82059 16.0318 9.94794 15.5133 9.94794 14.5524V1.44615C9.94794 0.485216 8.82059 -0.0332212 8.09075 0.593966Z" fill="#6c89b7" />
      </svg>

      <Text mr={'16px'}> Page{' '}</Text>
      <Select
        menuPlacement="top"
        isSearchable={false}
        styles={ReactSelectStyles.initialStyles}
        options={pages}
        value={selpage}
        onChange={(val) => {
          goToPage(val && val.value ? val.value : 0)
        }} />
      <Text ml={'16px'} mr={'16px'}>{`/ ${page.totalPages}`}</Text>

      <svg onClick={goToNext} width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'rotate(180deg)', marginRight: '16px', cursor: page.currentPage < page.totalPages - 1 ? 'pointer' : 'not-allowed', opacity: page.currentPage < page.totalPages - 1 ? 1 : 0.1 }}>
        <path d="M8.09075 0.593966L0.4445 7.14615C0.321318 7.25177 0.222439 7.38278 0.154648 7.5302C0.086857 7.67762 0.0517578 7.83796 0.0517578 8.00022C0.0517578 8.16248 0.086857 8.32282 0.154648 8.47023C0.222439 8.61765 0.321318 8.74866 0.4445 8.85428L8.09075 15.4065C8.82059 16.0318 9.94794 15.5133 9.94794 14.5524V1.44615C9.94794 0.485216 8.82059 -0.0332212 8.09075 0.593966Z" fill="#6c89b7" />
      </svg>
      <svg onClick={goToLast} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'rotate(180deg)', cursor: page.currentPage < page.totalPages - 1 ? 'pointer' : 'not-allowed', opacity: page.currentPage < page.totalPages - 1 ? 1 : 0.1 }}>
        <path d="M15.5 1.48875V16.5112C15.4972 16.7772 15.4237 17.0376 15.2872 17.2658C15.1506 17.494 14.9558 17.6818 14.7227 17.8099C14.4896 17.938 14.2267 18.0019 13.9608 17.9949C13.695 17.988 13.4357 17.9105 13.2097 17.7703L2 10.7597V17.25C2 17.4489 1.92098 17.6397 1.78033 17.7803C1.63968 17.921 1.44891 18 1.25 18C1.05109 18 0.860322 17.921 0.71967 17.7803C0.579018 17.6397 0.5 17.4489 0.5 17.25V0.75C0.5 0.551088 0.579018 0.360322 0.71967 0.21967C0.860322 0.0790178 1.05109 0 1.25 0C1.44891 0 1.63968 0.0790178 1.78033 0.21967C1.92098 0.360322 2 0.551088 2 0.75V7.24031L13.2097 0.229688C13.4354 0.0879731 13.695 0.0091765 13.9614 0.00145626C14.2278 -0.00626398 14.4915 0.0573728 14.7251 0.185778C14.9586 0.314183 15.1536 0.502688 15.2899 0.731776C15.4261 0.960865 15.4987 1.22221 15.5 1.48875Z" fill="#6c89b7" />
      </svg>

    </Flex>
  )
}
const HealthCoachingUsers: React.FC = () => {
  const navigate = useNavigate()
  const [hoveredId, setHoveredId] = useState<string | null>(null)
  const [showOnlyMine, setShowOnlyMine] = useState(false)
  const { data, error, loading, refetch } = useQuery<IGetHealthCoachingPatientsListOutput, IGetHealthCoachingPatientsListInput>(GET_HEALTHCOACHING_PATIENTS_LIST);
  const goToPage = (pageNumber: number) => {
    refetch({
      page: pageNumber
    })
  }
  useEffect(() => {
    refetch({
      page: 0,
      onlyMe: showOnlyMine
    })
  }, [showOnlyMine])
  if (loading && !data) {
    return (
      <Flex flexDirection={'column'} flex={1} mb={[3, 0, 0]} overflow={'hidden'}>
        <Heading>Health Coaching Patients</Heading>
        <Wrapper>
          <>
            {[1, 2, 3, 4].map(x => {
              return <RowLoading key={`loadingRow${x}`} />
            })}
          </>
        </Wrapper>
      </Flex>
    )
  }
  if (!data || !data.getHealthCoachingPatientsList || !data.getHealthCoachingPatientsList.patients || data.getHealthCoachingPatientsList.patients.length < 1) {
    return (<Flex flexDirection={'column'} flex={1} mb={[3, 0, 0]} overflow={'hidden'}>
      <Flex>
        <Heading mr={4}>{`Health Coaching Patients`}</Heading>

        <Checkbox label='Show only mine' isChecked={showOnlyMine} onClick={() => { setShowOnlyMine(!showOnlyMine) }} />
      </Flex>
      <Text textAlign={'center'} mt={'42px'} fontSize={'20px'} opacity={0.5}>No patients found matching those filters</Text>
    </Flex>)
  }

  return (
    <Flex flexDirection={'column'} flex={1} mb={[3, 0, 0]} overflow={'hidden'}>
      <Flex>
        <Heading mr={4}>{`Health Coaching Patients (${data.getHealthCoachingPatientsList.page.totalPatients} patients)`}</Heading>

        <Checkbox label='Show only mine' isChecked={showOnlyMine} onClick={() => { setShowOnlyMine(!showOnlyMine) }} />
      </Flex>
      <Header />
      <Wrapper>
        {data?.getHealthCoachingPatientsList.patients.map(x => {
          return (
            <Row hoveredId={hoveredId} setHover={setHoveredId}
              onGoToMessages={() => {
                if(!x.athenaId) return
                navigate(`/messages/${x.athenaId}&s=true&target=ai`)
              }}
              onGoToProfile={() => {
                if (!x.athenaId) return
                navigate(`/patient/${x.athenaId}`)
              }} 
              row={x} key={x.id} />
          )
        })}
      </Wrapper>
      <Footer page={data?.getHealthCoachingPatientsList.page} goToPage={goToPage} />
    </Flex>
  )
}

export default HealthCoachingUsers